<!--w-220px-->
<div class="flex bg-white box-border cursor-pointer flex-col sm:flex-col justify-between p-17px gap-4"
  [ngClass]="{'w-220px': !resize, 'us:flex-row h-auto sm:h-362px': turn, 'h-362px': !turn }">
  <a [routerLink]="cardNavigation()"  [queryParams]="queryParams" class="relative"
    [ngClass]="{'h-100px w-100px sm:w-full sm:h-149px': turn, 'w-full h-149px': !turn}">
    <!-- <img class="absolute w-6 top-4 right-4 z-10" src="../../../../../assets/imgs/product-card/icon-wish.svg" alt=""> -->
    <div class="grid-img absolute w-full h-full z-10 opacity-70 transition-all ease-in-out duration-700">
    </div>
    <img (load)="loadedImg($event)" class="relative object-contain transition-all ease-in-out duration-700 opacity-0"
      [ngClass]="{'h-100px w-100px sm:w-full sm:h-149px': turn, 'w-full h-149px': !turn}"
      src="{{imageUrl || '../../../../../assets/imgs/product-card/no-product-image'}}" alt="">
  </a>

  <div class="flex flex-col"
    [ngClass]="turn == true ? 'us:w-64% us-landscape:w-full md:w-full lg-landscape:w-full' : 'w-full'">
    <a class="relative w-full font-Lato-Regular text-blue-#18396C line-clamp-3 text-sm leading-tight"
      [routerLink]="cardNavigation()"  [queryParams]="queryParams">
      {{name}}
    </a>
<!--      <a *ngIf="store == null" class="relative font-Lato-Regular font-semibold text-10px"-->
<!--         [routerLink]="['/', getSelectedZone?.area_selected?.toLowerCase() || 'cu', newStore.code]">-->
<!--          {{newStore.name}}-->
<!--      </a>-->
    <a class="relative font-Lato-Regular font-semibold text-10px" [style.color]="(store | async)?.favorite_color"
      [routerLink]="['/', getSelectedZone?.area_selected?.toLowerCase() || 'cu', (store | async)?.code]">
      {{(store | async)?.name}}
    </a>
    <a class="relative w-full font-Lato-Regular text-gray-#212121 font-bold text-xl"
      [routerLink]="cardNavigation()"  [queryParams]="queryParams">
      <div *ngIf="product_type == 0">
          {{price | currency: currency}}
          <!--      *ngIf="compare_at_price && compare_at_price != 0"-->
          <span class="relative text-sm ml-2 text-red-400 line-through font-normal" *ngIf="discount?.hasDiscount">
            ${{discount?.labelLineThrough}}
          </span>
      </div>
    </a>

    <a class="relative w-full flex justify-start items-center h-5 mt-3px"
      [routerLink]="cardNavigation()"  [queryParams]="queryParams">
      <p *ngIf="isLowStock"
        class="relative font-Lato-Regular font-medium bg-green-#78840D text-white h-full text-13px pl-2 pr-2 rounded-10px">
        low stock</p>
      <p *ngIf="discount?.hasDiscount"
        class="relative font-Lato-Regular font-medium bg-yellow-#FFA101 text-white h-full text-13px pl-2 pr-2 rounded-10px m-1">
        -{{discount?.labelPercent | number:'1.0-0'}}%</p>
      <p *ngIf="false"
        class="relative font-Lato-Regular font-medium bg-blue-#089CE3 text-white h-full text-13px pl-2 pr-2 rounded-10px m-1">
        best
        seller</p>
      <p *ngIf="shipping_category"
        class="relative font-Lato-Regular font-medium bg-yellow-#FFA101 text-white h-full text-13px pl-2 pr-2 rounded-10px">
        {{shipping_category}}</p>
    </a>
    <div *ngIf="product_type == 0" class="relative w-full flex justify-between items-center mt-3">
      <div
        class="relative flex justify-center items-center border border-gray-#929292 overflow-hidden box-border rounded-l-20px rounded-r-20px h-35px">
        <button (click)="decreaseQuantity()" [disabled]="data_extra_types?.length !== 0" class="relative cursor-pointer h-full bg-gray-#f2f2f2 flex justify-center items-center font-Lato-Regular text-gray-#979797
            text-25px w-38px">
          -
        </button>
        <p (click)="setCustomQuantity()"
          class="relative overflow-hidden cursor-pointer h-full flex justify-center items-center font-Lato-Regular text-gray-#5d5d5d w-38px text-17px">
          {{quantity}}</p>
        <button (click)="increaseQuantity()" [disabled]="data_extra_types?.length !== 0"
          [ngClass]="this.quantity >= compare_top && compare_top !== null && compare_top !== undefined ? 'cursor-not-allowed':'cursor-pointer'"
          class="relative cursor-pointer h-full bg-gray-#f2f2f2 flex justify-center items-center font-Lato-Regular text-gray-#979797
            text-25px w-38px">
          +
        </button>
      </div>
      <fa-icon *ngIf="spin"
        class="relative flex justify-center items-center animate-spin  bg-yellow-#FF6D03 rounded-full w-9 h-9 text-xl text-white"
        [icon]="faSpinner">
      </fa-icon>
      <fa-icon *ngIf="!spin" [ngClass]="{'opacity-50 cursor-not-allowed': isBlockAddToCard}"
        class="relative flex justify-center items-center  bg-yellow-#FF6D03 rounded-full w-9 h-9 text- text-white"
        [icon]="cart_icon" (click)="addToCart()">
      </fa-icon>
    </div>

      <div *ngIf="product_type == 1" (click)="navigateTo()" class="relative px-5 cursor-pointer w-80% bg-yellow-#FF6D03 font-Lato-Regular text-white h-9 rounded-full
      flex justify-center items-center leading-none">
          <p class="relative text-base leading-none">{{navigation.labelText | translate}}</p>
      </div>

  </div>
</div>
